export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14041.9b805c33.jpg";